import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
} from "@mui/joy";
import { Stack } from "@mui/material";
import * as React from "react";
import { useLocation, useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import {
  CurrencyFormat,
  toCoinAmount,
  toUsdAmount,
} from "../config/services";

export default function Send() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const { code, balance, price } = state;
  const [data, setData] = React.useState({
    amount: 0,
    coin: 0,
    address: "",
    network: "Bitcoin",
  });

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const setCurrency = (event, amount) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
      amount: amount,
    });
  };

  const pasteAddress = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setData({ ...data, address: text });
    } catch (error) {
      console.error("Failed to read clipboard contents: ", error);
    }
  };

  const setMaxAmount = () => {
    if (balance > 0) {
      setData({
        ...data,
        coin: toCoinAmount(balance, price),
        amount: balance,
      });
    }
  };

  return (
    <>
      <HeaderBackButton title={`Send ${code}`} />

      <Container maxWidth="sm">
        <Stack spacing={6} mt={4}>
          <FormControl>
            <FormLabel>Receiver {code} address</FormLabel>
            <Input
              size="lg"
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              name="address"
              placeholder="Address"
              type="text"
              required
              value={data.address}
              onChange={handleChange}
              error={data.status === "failure"}
              endDecorator={
                <Button
                  variant="soft"
                  color="neutral"
                  type="submit"
                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={pasteAddress}
                >
                  Paste
                </Button>
              }
            />
          </FormControl>

          <FormControl>
            <FormLabel>{code} amount</FormLabel>
            <Input
              name="coin"
              size="lg"
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              placeholder="0.00"
              type="number"
              required
              value={data.coin}
              onChange={(event) => {
                handleChange(event);
                if (event.target.value > 0) {
                  setCurrency(event, toUsdAmount(event.target.value, price));
                }
              }}
              error={data.status === "failure"}
              endDecorator={
                <Button
                  variant="solid"
                  color="primary"
                  loading={data.status === "loading"}
                  type="submit"
                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={setMaxAmount}
                >
                  Max
                </Button>
              }
            />
            <FormHelperText>
              Receiver gets{" "}
              <CurrencyFormat
                amount={data.amount}
                prefix={"$"}
                seperator={true}
              />
            </FormHelperText>
          </FormControl>

          <Button
            variant="solid"
            color="primary"
            fullWidth
            size="lg"
            disabled={
              balance < data.amount || balance == 0 || data.amount < 100000
            }
            onClick={() =>
              navigate("/passcode", {
                state: {
                  coin: state,
                  data: data,
                },
              })
            }
          >
            Continue
          </Button>
        </Stack>
      </Container>
    </>
  );
}
